import { render, staticRenderFns } from "./PropertiesCard.vue?vue&type=template&id=7b31f5c1&scoped=true"
import script from "./PropertiesCard.vue?vue&type=script&lang=js"
export * from "./PropertiesCard.vue?vue&type=script&lang=js"
import style0 from "./PropertiesCard.vue?vue&type=style&index=0&id=7b31f5c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b31f5c1",
  null
  
)

export default component.exports